/* OLAPLEX #39 — arrastre con mouse en los carruseles (ul.slider de Dawn).
   El overflow nativo en desktop solo responde a rueda/trackpad; esto agrega
   click-and-drag. Tras un arrastre real se suprime el click que el navegador
   dispara al soltar, para no abrir el link/carta del slide. */
(function () {
  var THRESHOLD = 8;

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var track = e.target.closest('ul.slider');
    if (!track || track.scrollWidth <= track.clientWidth + 1) return;
    e.preventDefault(); // evita selección de texto y drag nativo de imágenes/links

    var startX = e.clientX;
    var startScroll = track.scrollLeft;
    var dragged = false;
    var prevSnap = track.style.scrollSnapType;

    function onMove(ev) {
      var dx = ev.clientX - startX;
      if (!dragged) {
        if (Math.abs(dx) < THRESHOLD) return;
        dragged = true;
        track.style.scrollSnapType = 'none';
        track.classList.add('is-dragging');
      }
      track.scrollLeft = startScroll - dx;
    }

    function onUp() {
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
      window.removeEventListener('pointercancel', onUp);
      if (!dragged) return;
      track.classList.remove('is-dragging');
      track.style.scrollSnapType = prevSnap;
      var block = function (ce) { ce.preventDefault(); ce.stopPropagation(); };
      track.addEventListener('click', block, true);
      setTimeout(function () { track.removeEventListener('click', block, true); }, 0);
    }

    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
  });
})();
